// src/map/markers/popup.ts
import { Station, DataSample, DataSampleType, DataSampleUnit } from "../../domain/types";
import { formatData } from "../data/formattingData";
import { getBadges } from "./circleIcon";
import { createTooltip } from "./tooltip";

/**
 * Build the popup HTML for a station.
 * Reuses the tooltip header, then adds a compact data block.
 */
export function createPopup(s: Station): string {
    return `<h3 class="tooltip-header">${s.Name} ${getBadges(s, 40, true).html}</h3>${formatData(s)}`;
}
